import { courseTypesLabels } from '@/constants/catalog/course';
import {
  GoalLabels,
  LanguageLabels,
  ScholarityLabels,
  SeniorityLabels,
} from '@/constants/recommendation';
import { ProfileStepIds } from '@/models/recommendation';
import { type QuizAnswers } from '@/packages/profile-quiz/context/profile-quiz/types';

const stepHandlers: Partial<
  Record<ProfileStepIds, (values: QuizAnswers) => string | string[] | undefined>
> = {
  [ProfileStepIds.LocationInfo]: (values) =>
    values.non_resident
      ? 'Não moro no Brasil'
      : [values.address_city, values.address_state].join(' - '),

  [ProfileStepIds.Scholarity]: (values) =>
    values.scholarity ? ScholarityLabels[values.scholarity] : '',

  [ProfileStepIds.Seniority]: (values) =>
    values.seniority ? SeniorityLabels[values.seniority] : '',

  [ProfileStepIds.CurrentJob]: (values) => values.current_job?.name,
  [ProfileStepIds.DesiredJob]: (values) => values.desired_job?.name,
  [ProfileStepIds.Languages]: (values) =>
    values.languages?.map((language) => LanguageLabels[language]),
  [ProfileStepIds.CourseTypes]: (values) =>
    values.course_types?.map((courseType) => courseTypesLabels[courseType]),
  [ProfileStepIds.Goal]: (values) =>
    values.goal ? GoalLabels[values.goal] : '',
  [ProfileStepIds.ContactInfo]: (values) => {
    const notReceiveEmailsLabel = 'Não quero receber e-mails';

    const labels = [
      ...(values.email ? [`E-mail: ${values.email}`] : []),
      ...(values.phone ? [`Telefone: ${values.phone}`] : []),
    ];

    const shouldReturnNotReceiveEmails =
      labels.length === 0 || !values.agreed_to_receive_emails;

    return shouldReturnNotReceiveEmails ? notReceiveEmailsLabel : labels;
  },
};

export const quizAnswerToLabel = (key: ProfileStepIds, values: QuizAnswers) =>
  stepHandlers[key]?.(values) ?? '';
